import React from 'react';
import { Button, Modal, Result } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';
import { useTenantColors } from 'hooks/useTenantColors';

// Oferta posterior a crear una ODT: sin esto el flujo terminaba en un toast y la
// carta Gantt solo se descubría entrando a la pestaña ODT del cliente. Se muestra
// solo al crear (no al editar) y permite ir directo a planificar o dejarlo para después.
function PlanificarOdtModal({ open, idOrder, onPlan, onClose }) {
  const { secondary } = useTenantColors();

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered destroyOnHidden width={480}>
      <Result
        status="success"
        title={`ODT #${idOrder} creada`}
        subTitle="¿Quieres planificarla ahora? En la carta Gantt puedes asignar fechas a cada tarea, ordenarlas y definir cuál depende de cuál."
        extra={[
          <Button key="despues" onClick={onClose}>
            Más tarde
          </Button>,
          <Button
            key="planificar"
            type="primary"
            icon={<ProjectOutlined />}
            onClick={onPlan}
            style={{ background: secondary, borderColor: secondary }}
          >
            Planificar en la carta Gantt
          </Button>,
        ]}
      />
    </Modal>
  );
}

export default PlanificarOdtModal;
